export const reasonsData = [
  {
    title: "Fizičko zdravlje",
    reasons: [
      { number: "1", text: "Poboljšava zdravlje srca: Jača srce i smanjuje rizik od srčanih bolesti." },
      { number: "2", text: "Povećava mišićnu snagu: Gradi i oblikuje mišiće." },
      { number: "3", text: "Povećava gustoću kostiju: Smanjuje rizik od osteoporoze." },
      { number: "4", text: "Pomaže u održavanju težine: Sagorijeva kalorije i pomaže održavanju zdrave težine." },
      { number: "5", text: "Poboljšava fleksibilnost: Smanjuje rizik od ozljeda i povećava opseg pokreta." },
      { number: "6", text: "Podupire zdravlje zglobova: Održava zglobove podmazanima i pokretnima." },
      { number: "7", text: "Poboljšava držanje: Jača mišiće trupa i smanjuje bolove u leđima." },
      { number: "8", text: "Podiže imunološki sustav: Pomaže tijelu da se bori protiv bolesti." },
      { number: "9", text: "Smanjuje rizik od kroničnih bolesti: Snižava rizik od dijabetesa, hipertenzije i određenih vrsta raka." },
      { number: "10", text: "Povećava metabolizam: Podiže bazalni metabolizam čak i u mirovanju." },
      { number: "11", text: "Poboljšava probavu: Potiče redovit rad crijeva." },
      { number: "12", text: "Poboljšava kvalitetu sna: Omogućuje dublji i obnoviteljski san." }
    ]
  },
  {
    title: "Mentalne i emocionalne koristi",
    reasons: [
      { number: "13", text: "Smanjuje stres: Oslobađa endorfine, prirodne \"ublaživače\" stresa." },
      { number: "14", text: "Poboljšava raspoloženje: Djeluje kao prirodni antidepresiv oslobađanjem serotonina i dopamina." },
      { number: "15", text: "Povećava samopouzdanje: Poboljšava tjelesni imidž i samopouzdanje." },
      { number: "16", text: "Smanjuje anksioznost: Ima smirujući učinak na um." },
      { number: "17", text: "Poboljšava fokus i koncentraciju: Unapređuje kognitivne funkcije." },
      { number: "18", text: "Potakne svjesnost: Pomaže da ostanete prisutni u trenutku." },
      { number: "19", text: "Gradi mentalnu otpornost: Uči disciplinu i ustrajnost." }
    ]
  },
  {
    title: "Društvene koristi",
    reasons: [
      { number: "20", text: "Potiče uključenost u zajednicu: Pridružite se grupama ili tečajevima fitnessa i upoznajte nove ljude." },
      { number: "21", text: "Jača prijateljstva: Vježbanje s prijateljima potiče povezivanje i motivaciju." },
      { number: "22", text: "Promiče timski rad: Naučite suradnju kroz timske sportove ili vježbe u paru." }
    ]
  },
  {
    title: "Životne i funkcionalne koristi",
    reasons: [
      { number: "23", text: "Povećava razinu energije: Povećava ukupnu vitalnost i smanjuje umor." },
      { number: "24", text: "Povećava produktivnost: Čini vas učinkovitijima u svakodnevnim zadacima." },
      { number: "25", text: "Potiče bolje upravljanje vremenom: Prioritet fitnessa strukturira vaš dan." },
      { number: "26", text: "Potiče zdravije prehrambene navike: Fitness često inspirira poboljšanje prehrane." },
      { number: "27", text: "Poboljšava tjelesnu mehaniku: Poboljšava ravnotežu, koordinaciju i agilnost." },
      { number: "28", text: "Priprema za starenje: Održava neovisnost i fizičku sposobnost u starijoj dobi." },
      { number: "29", text: "Povećava izdržljivost: Omogućuje dulje vrijeme aktivnog kretanja." }
    ]
  },
  {
    title: "Estetske i izvedbene koristi",
    reasons: [
      { number: "30", text: "Oblikuje tijelo: Poboljšava tonus mišića i smanjuje tjelesnu masnoću." },
      { number: "31", text: "Poboljšava sportsku izvedbu: Povećava snagu, brzinu i izdržljivost." },
      { number: "32", text: "Potiče postavljanje ciljeva: Promiče osjećaj postignuća kroz dosezanje fitness ciljeva." }
    ]
  },
  {
    title: "Opća kvaliteta života",
    reasons: [
      { number: "33", text: "Produljuje životni vijek: Promiče duži, zdraviji i ispunjeniji život." }
    ]
  }
];